// import colors from 'vuetify/lib/util/colors';

export default {
  grey: {
    base: '#A0AEC0',
    lighten4: '#F7FAFC',
    lighten3: '#EDF2F7',
    lighten2: '#E2E8F0',
    lighten1: '#CBD5E0',
    darken1: '#718096',
    darken2: '#4A5568',
    darken3: '#2D3748',
    darken4: '#1A202C',
  },
  blue: {
    base: '#4299E1',
    lighten4: '#EBF8FF',
    lighten3: '#BEE3F8',
    lighten2: '#90CDF4',
    lighten1: '#63B3ED',
    darken1: '#3182CE',
    darken2: '#2B6CB0',
    darken3: '#2C5282',
    darken4: '#2A4365',
  },
  red: {
    base: '#F56565',
    lighten4: '#FFF5F5',
    lighten3: '#FED7D7',
    lighten2: '#FEB2B2',
    lighten1: '#FC8181',
    darken1: '#E53E3E',
    darken2: '#C53030',
    darken3: '#9B2C2C',
    darken4: '#742A2A',
  },
  green: {
    base: '#48BB78',
    lighten4: '#F0FFF4',
    lighten3: '#C6F6D5',
    lighten2: '#9AE6B4',
    lighten1: '#68D391',
    darken1: '#38A169',
    darken2: '#2F855A',
    darken3: '#276749',
    darken4: '#22543D',
  },
  orange: {
    base: '#ED8936',
    lighten4: '#FFFAF0',
    lighten3: '#FEEBC8',
    lighten2: '#FBD38D',
    lighten1: '#F6AD55',
    darken1: '#DD6B20',
    darken2: '#C05621',
    darken3: '#9C4221',
    darken4: '#7B341E',
  },
  yellow: {
    base: '#ECC94B',
    lighten4: '#FFFFF0',
    lighten3: '#FEFCBF',
    lighten2: '#FAF089',
    lighten1: '#F6E05E',
    darken1: '#D69E2E',
    darken2: '#B7791F',
    darken3: '#975A16',
    darken4: '#744210',
  },
  teal: {
    base: '#38B2AC',
    lighten4: '#E6FFFA',
    lighten3: '#B2F5EA',
    lighten2: '#81E6D9',
    lighten1: '#4FD1C5',
    darken1: '#319795',
    darken2: '#2C7A7B',
    darken3: '#285E61',
    darken4: '#234E52',
  },
  indigo: {
    base: '#667EEA',
    lighten4: '#EBF4FF',
    lighten3: '#C3DAFE',
    lighten2: '#A3BFFA',
    lighten1: '#7F9CF5',
    darken1: '#5A67D8',
    darken2: '#4C51BF',
    darken3: '#434190',
    darken4: '#3C366B',
  },
  purple: {
    base: '#9F7AEA',
    lighten4: '#FAF5FF',
    lighten3: '#E9D8FD',
    lighten2: '#D6BCFA',
    lighten1: '#B794F4',
    darken1: '#805AD5',
    darken2: '#6B46C1',
    darken3: '#553C9A',
    darken4: '#44337A',
  },
  pink: {
    base: '#ED64A6',
    lighten4: '#FFF5F7',
    lighten3: '#FED7E2',
    lighten2: '#FBB6CE',
    lighten1: '#F687B3',
    darken1: '#D53F8C',
    darken2: '#B83280',
    darken3: '#97266D',
    darken4: '#702459',
  },
  primary: '#4299E1',
  secondary: '#4A5568',
  error: '#F56565',
  warning: '#ED8936',
  info: '#38B2AC',
  success: '#48BB78',
  // All keys will generate theme styles,
  // Here we add a custom `tertiary` color
  tertiary: '#EDF2F7',
};
